// axios
import axios from 'axios'

// LOCALHOST
//const baseURL = 'http://127.0.0.1:8081/'

// STAGING
// const baseURL = 'https://hov-extended-api-stag.herokuapp.com/'

// PROD
const baseURL = 'https://hov-extended-api-prod.herokuapp.com/'

//http://127.0.0.1:3000/
//const baseURL = "http://192.168.1.32:8081/"
export default axios.create({
  baseURL,
  // You can add your headers here
})
